import { useState } from "react";
import { ApiFactory } from "../../core/config/ApiFactory";
import { useSnackbar } from "../../core/contexts/SnackbarContext";
import { ITema } from "../../core/interfaces/ITema";
import { IImagemTema } from "../../core/interfaces/IImagemTema";
import { clearAllCache } from "../../core/services/indexedDBCache";

export const useTema = () => {
    const [loading, setLoading] = useState(false);
    const snackbar = useSnackbar();
    const apiEstabelecimentos = ApiFactory.getApi("MS_ESTABELECIMENTOS");

    const uploadImagem = async (file: File, tipo: "Logo"): Promise<IImagemTema | null> => {
        setLoading(true);
        const formData = new FormData();
        formData.append('imagem', file);

        try {
            const { data } = await apiEstabelecimentos.post(`/tema/imagem/${tipo}`, formData);
            return data;
        } catch (error) {
            snackbar("Ocorreu um erro ao fazer upload da imagem", { severity: "error" });
            return null;
        } finally {
            setLoading(false);
        }
    };

    const salvarTema = async (tema: Partial<ITema>): Promise<boolean> => {
        setLoading(true);
        try {
            await apiEstabelecimentos.post('/tema/', tema);
            // Limpar cache após salvar tema
            await clearAllCache();
            return true;
        } catch (error) {
            snackbar("Ocorreu um erro ao salvar o tema", { severity: "error" });
            return false;
        } finally {
            setLoading(false);
        }
    };

    const buscarTema = async (modo: "light" | "dark"): Promise<ITema | null> => {
        setLoading(true);
        try {
            const { data } = await apiEstabelecimentos.get(`/tema/${modo}`);
            return data;
        } catch (error) {
            return null;
        } finally {
            setLoading(false);
        }
    };

    const limparTema = async (modo: "light" | "dark"): Promise<boolean> => {
        setLoading(true);
        try {
            await apiEstabelecimentos.delete(`/tema/${modo}`);
            // Limpar cache após deletar tema
            await clearAllCache();
            return true;
        } catch (error) {
            snackbar("Ocorreu um erro ao limpar o tema", { severity: "error" });
            return false;
        } finally {
            setLoading(false);
        }
    };

    return {
        uploadImagem,
        salvarTema,
        buscarTema,
        limparTema,
        loading
    };
};

